import { Component } from '@angular/core';
import { AppConstants } from '@core/constants/app';
import { environment } from '@environment/environment';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-blue-button',
  templateUrl: './blue-button.component.html',
  styleUrls: ['./blue-button.component.scss']
})
export class BlueButtonComponent {

  public readonly translationPrefix = 'pages.blueButtonPage';
  public blueButton: { termsUrl: string, privacyUrl: string };
  constructor(private translate: TranslateService) {
         this.blueButton =  {
            termsUrl: AppConstants.TERMS_AND_CONDITIONS_URL_MAPPING()[this.translate.currentLang],
            privacyUrl: AppConstants.PRIVACY_POLICY_URL_MAPPING()[this.translate.currentLang],
          };

  }

  public blueButtonClick() {
    window.open(environment.services.blueButton.url, '_blank');
  }

}
